export default __webpack_public_path__ + "static/media/img_info2_3.45b9e6b7.png";